import * as API from "@/api/index.js"
export default {

  data(){
    return{
      temp_func_data:[],
      $_menu_list: [],
      $_menu_dict:{},
    }
  },

  mounted(){
    this.$_getRole();
  },

  methods:{

    async $_getUserRoleFunc(no_env, server_env_id) {   //获取角色功能权限数据   处理返回
      let response, datas;
      if(no_env){
        datas = {no_env: true}
      }else if(!no_env && server_env_id){
        datas = {server_env_id: server_env_id}
      }
      response = await API.GET('/omnis/system/user_func_role', datas)
      let data = response.data
      var func_dict = {}
      if (data.success) {
            data.data.map((items) =>{
              let field_name = items.env_id ? items.env_id : "func"
              if(!func_dict.hasOwnProperty(field_name)){
                func_dict[field_name] = []
              }
              if(func_dict[field_name].indexOf(items.func_code) === -1){
                func_dict[field_name].push(items.func_code)
              }

            })
      }
      return func_dict
    },

    $_getRole(){
      this.$_global_params.menu_list.then((res) =>{
        this.$_menu_list = res
        this.$_menu_dict = {}
        this.$_ListToDict(this.$_menu_dict, this.$_menu_list)

      })
      // this.$_global_params.user_func_role.then((res) =>{
      //   this.temp_func_data = res
      // })
    },

    $_ListToDict(data_dict,data_list, field){
      data_list.forEach(row =>{
        data_dict[row.menu_url] = row.menu_code
          if(row.children && row.children.length > 0){
            let children = row.children
            this.$_ListToDict(data_dict, children)
          }
      })
    },

    $_returnRole(env_func_arr, right_data){
      // console.log(window.location.href)
      var env_id = env_func_arr[0]
      var func_text = env_func_arr[1]
      var temp_dict = {}
      temp_dict[env_func_arr[0]] = env_func_arr[1]

      if(right_data && JSON.stringify(right_data) !== '{}'){
        if((right_data[env_id] && right_data[env_id].indexOf(func_text) > -1) || env_id === this.$_global_params.treeIDNull){
          return false  // 存在  disabled不生效
        }else {
          return true
        }
      }


      if(JSON.stringify(this.temp_func_data).indexOf(JSON.stringify(temp_dict)) > -1 || env_func_arr[0] == this.$_global_params.treeIDNull){
        return false   // 存在  disabled不生效
      }else {
        return true
      }
    },

    $_btnIsDisabled(env_func_arr){
      return this.$_returnRole(env_func_arr)
    },

    $_btnTitle(env_func_arr,title, right_sata){
      if(this.$_returnRole(env_func_arr, right_sata)){
        return "没有权限"
      }else {
        return title
      }
    },

    $_addCursorStyle(env_func_arr){
      if(this.$_returnRole(env_func_arr)){
        return "cursor: not-allowed"
      }else {
        return "cursor: pointer"
      }
    },

    $_treeIDIsNull(treeID){
      if(!treeID){
        return this.$_global_params.treeIDNull
      }else {
        return treeID
      }
    },

  }
}



// WEBPACK FOOTER //
// ./src/api/userfuncrole_func.js